import { Component, Input, OnInit, EventEmitter, Output, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { LU_Keyword } from '../models/keyword';
import { GalleryTypeService } from '../services/gallery-type.service';
import { StarbaseModalButton, StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalTypes } from 'starbase-modal-dialog';
import { FilterParams } from 'starbase-launcher';
import { ImageFile } from '../models/imageFile';
import { KeywordDataService } from '../services/keyword-data.service';
import { BreakpointService } from '../breakpoint.service';

@Component({
  selector: 'app-keyword-badge',
  templateUrl: './keyword-badge.component.html',
  styleUrls: ['./keyword-badge.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KeywordBadgeComponent implements OnInit {
  /** The target object */
  @Input() keyword: LU_Keyword;
  @Input() restrictEdit: boolean = false;
  /** Matching substrings in keyword will be highlighted.
   * Send in as lowercase. */
  @Input() searchText: string;
  /** Set to true when this keyword equals the filtered keyword. */
  @Input() filterMatchText = '';
  /** Override the font size in _rems_.
   * @default 1.25 */
  @Input() fontSize = '1.25'; // rem
  /** When true, the Me button will show. */
  @Input() editMode = false;
  /** Emits when a keyword filter has been set. */
  @Output() filterByMeEmitter = new EventEmitter<LU_Keyword>();
  /** Emits when an associated `KeywordLink` is to be deleted. The listener must pair this info with an `ImageModel` Id to form a KeywordLinking model. */
  @Output() deleteMeEmitter = new EventEmitter<LU_Keyword>();

  @ViewChild('confirmFilterModal', { static: true }) confirmFilterModal: TemplateRef<any>;

  private currentFilters: FilterParams<ImageFile>;

  filterMatchMode = false;
  matchesSynonymSearch = false;
  matchesHierarchySearch = false;
  isHandset: boolean = false;
  private _subscription;

  constructor(protected gallerySvc: GalleryTypeService, private modalSvc: StarbaseModalDialogService, protected keywordSvc: KeywordDataService, private breakpointSvc: BreakpointService) { }

  ngOnInit() {
    this._subscription = this.breakpointSvc.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    )

    this.filterMatchMode = this.filterMatchText === this.keyword.keyword;
    this.matchesSynonymSearch = this.keywordSvc.isSynonymOfKeywordText(this.keyword, this.filterMatchText);
    this.matchesHierarchySearch = this.keywordSvc.isDependentOfKeywordText(this.keyword, this.filterMatchText);
  }

  deleteMe(): void {
    if (this.editMode) {
      this.deleteMeEmitter.emit(this.keyword);
    }
  }

  /** Checks if there are already filters in the gallery service.
   * If there are, presents the user with a modal confirmation box.
   * Upon yes, sets the filters to "this" keyword. */
  changeFilterToMe(event?: Event): void {
    if (event) { event.stopPropagation(); }
    if (this.filterMatchMode) { return; }
    if (this.gallerySvc.CountOfFiltersIgnoreImageType > 0 || this.gallerySvc.HasActiveSearch) {
      let confirmFilterModal = new StarbaseModalOptions(
          'Confirm filter replacement',
          '',
          [
            new StarbaseModalButton(
              'No, keep current filters',
              () => this.modalSvc.closeModal('User chose to cancel keyword filter')
            ),
            new StarbaseModalButton(
              'Yes',
              () => {
                const fp = new FilterParams<ImageFile>();
                this.currentFilters = this.gallerySvc.getCurrentLibraryFilters();
                const galleryType = this.gallerySvc.getGalleryType();
                if (galleryType.uid && galleryType.uid > 0 && galleryType.typeOfImage !== 'All') {
                  fp.replaceFilter('TypeOfImageId', galleryType.uid);
                }

                const childrenUIDs = this.keywordSvc.getAllChildrenUIDs(this.keyword);
                const synonyms = this.keywordSvc.getKeywordSynonyms(this.keyword.uid);
                const children_keywords = [...childrenUIDs, ...synonyms.map(s => s.uid), this.keyword.uid];
                fp.addToFilter('ImageKeywords.LU_KeywordUID', children_keywords.join("|"));
                fp.searchPhrase = '';
                fp.page = 1;
                fp.rpp = 35;
                this.gallerySvc.clearCurrentFilterOptions();
                this.gallerySvc.setCurrentLibraryFilters(fp);
                this.gallerySvc.storeKeywordFilter(this.keyword.keyword);
                this.gallerySvc.clearLibraryImages();
                this.filterByMeEmitter.emit(this.keyword);
                this.modalSvc.closeModal('User chose to filter by keyword');
              }
            )
          ],
          StarbaseModalTypes.Info,
          this.confirmFilterModal
        )
        confirmFilterModal.forcedWidth = this.isHandset ? '90vw' : '';
        this.modalSvc.postModal(confirmFilterModal);
      
    } else {
      this.currentFilters = this.gallerySvc.getCurrentLibraryFilters();
      const childrenUIDs = this.keywordSvc.getAllChildrenUIDs(this.keyword);
      const synonyms = this.keywordSvc.getKeywordSynonyms(this.keyword.uid);
      const children_keywords = [...childrenUIDs, ...synonyms.map(s => s.uid), this.keyword.uid];
      this.currentFilters.addToFilter('ImageKeywords.LU_KeywordUID', children_keywords.join("|"));

      // this.currentFilters.replaceFilter('ImageKeywords.LU_KeywordUID', this.keyword.uid);
      this.currentFilters.page = 1;
      // this.currentFilters.searchPhrase = '';
      this.currentFilters.rpp = 35;
      this.gallerySvc.setCurrentLibraryFilters(this.currentFilters);
      this.gallerySvc.storeKeywordFilter(this.keyword.keyword);
      this.gallerySvc.clearLibraryImages();
      this.filterByMeEmitter.emit(this.keyword);
  }
    return;
  }

}
